import { render, staticRenderFns } from "./PageEntregaEquipo.vue?vue&type=template&id=79b8e30f&"
import script from "./PageEntregaEquipo.vue?vue&type=script&lang=js&"
export * from "./PageEntregaEquipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports